export default __webpack_public_path__ + "static/media/Diversity.272ff9c7.svg";